import { render, staticRenderFns } from "./ContasReceber.vue?vue&type=template&id=0e68c760"
import script from "./ContasReceber.vue?vue&type=script&lang=js"
export * from "./ContasReceber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports